<template>
  <v-row no-gutters>
    <feature-card-basic
      ref="featureCard"
      :layer="layer"
      @update:feature="featureFetched"
      :object-extras-tabs="['changeHistory', 'notes', 'relations']"
      :customAddNewObjectAction="addNewDocument"
      :custom-is-form-valid="hasFile || !isNew"
      :icons-to-show="['showHistory', 'showNotes']"
    >
      <template #top>
        <widget-document-informations v-if="!isNew" :attributes="feature.properties" class="pt-3 pb-1" />
        <sidebar-row v-if="isFileUploadVisible">
          <v-col cols="auto" class="px-0 pb-0">
            <file-input
              ref="file"
              :options="dropzoneOptions"
              :events="{
                'vdropzone-file-added': () => {
                  hasFile = true;
                },
                'vdropzone-removed-file': () => {
                  hasFile = false;
                },
              }"
            />
          </v-col>
        </sidebar-row>
      </template>
    </feature-card-basic>
  </v-row>
</template>
<script>
import { call, get } from 'vuex-pathify';
import FeatureCardBasic from '@/components/FeatureCardBasic';
import WidgetDocumentInformations from '@/components/WidgetDocumentInformations';
import FileInput from '@/components/FileInput';
import SidebarRow from '@/components/SidebarRow';
export default {
  name: 'FeatureCardDocument',
  components: { FeatureCardBasic, FileInput, SidebarRow, WidgetDocumentInformations },
  props: {
    layer: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    isAdminEnabled: get('admin/settingsValues@documentation_module_enabled'),
    isSuperAdminEnabled: get('admin/additionalModules@DOCUMENTATION.enabled'),
    modulesPermissions: get('users/toolsPermissions'),
    currentFeatureId() {
      return this.$route.params.fid;
    },
    dropzoneOptions() {
      return {
        url: '/',
        method: 'post',
        autoProcessQueue: false,
        uploadMultiple: false,
        addRemoveLinks: true,
        paramName: 'file',
        maxFiles: 1,
        init: function() {
          this.on('maxfilesexceeded', function(file) {
            this.removeAllFiles();
            this.addFile(file);
          });
        },
      };
    },
    isFileUploadVisible() {
      return this.isSuperAdminEnabled && this.isAdminEnabled && this.isNew && this.permissions.preview;
    },
    isNew() {
      return this.currentFeatureId === 'new';
    },
    permissions() {
      const value = this.modulesPermissions['DOCUMENTATION'].main_value;
      return {
        edit: value > 1,
        preview: value > 0,
        value,
      };
    },
  },
  data: () => ({
    hasFile: false,
    feature: undefined,
  }),
  methods: {
    addAttachment: call('relations/addAttachment'),
    async addNewDocument(payload) {
      const file = this.$refs.file.$refs.dropzone.getAcceptedFiles()[0];
      const { body } = payload;
      const formData = new FormData();
      formData.append('file', file);
      for (const key of Object.keys(body)) {
        const value = body[key];
        if (!value && value !== false && value !== 0) {
          continue;
        }
        formData.append(key, body[key]);
      }
      const r = await this.addAttachment(formData);
      this.$refs.file.$refs.dropzone.removeAllFiles();
      return r;
    },
    featureFetched($event) {
      this.feature = $event;
    },
  },
};
</script>
